import React, { Component } from 'react';
import ReactTable from 'react-table';
import { Button, Checkbox } from 'semantic-ui-react';

import { columns } from '../helpers/columns';
import { defaultSort } from '../helpers/constants';

class StudentGrid extends Component {
  state = {
    filtered: [],
  };

  columns = [
    ...columns,
    {
      Header: ({ data }) => {
        const { toggleCheckAll } = this.props;

        return (
          <Checkbox
            checked={data.length > 0 && data.every(s => s._original.Checked)}
            onClick={e => toggleCheckAll(data)}
          />
        );
      },
      accessor: 'Checked',
      resizable: false,
      sortable: true,
      Cell: ({ original }) => {
        return (
          <div style={styles.checkboxCell}>
            <Checkbox
              checked={original.Checked}
              onChange={() => this.props.toggleStudentChecked(original.IdSeed)}
            />
          </div>
        );
      },
    },
  ];

  onFilteredChange = filtered => {
    filtered.forEach(f => (f.value = f.value.toUpperCase()));
    this.setState({ filtered });
  };

  onClearFiltersClick = () => this.setState({ filtered: [] });

  render() {
    const { students, loading } = this.props;
    const { filtered } = this.state;

    return (
      <div>
        <Button
          floated="right"
          onClick={this.onClearFiltersClick}
          disabled={filtered.length === 0}
          style={styles.clearFiltersButton}
        >
          Clear Filters
        </Button>
        <ReactTable
          data={students}
          columns={this.columns}
          loading={loading}
          filtered={filtered}
          onFilteredChange={this.onFilteredChange}
          defaultSorted={defaultSort}
          minRows={5}
          showPageSizeOptions={false}
          multiSort
        />
      </div>
    );
  }
}

const styles = {
  clearFiltersButton: {
    marginBottom: 20,
  },
  checkboxCell: {
    textAlign: 'center',
  },
};

export { StudentGrid };



// WEBPACK FOOTER //
// ./src/pages/prohibiteditems/components/StudentGrid.js